(ns hai.web-app.components.form
  "Interim form components that were written as a stopgap before `hai.ui.components.form.core`.
  Slightly more abstracted form components, one step up from hard coded prompt fields which was the start."
  (:require
   [clojure.edn :as edn]
   [clojure.string :as str]
   [hai.ui.components :as c]
   [lambdaisland.ornament :as o]))

(o/defstyled form :div
  :flex :flex-col :gap-3
  [:.buttons :flex :flex-row :gap-3])

(defn munge-attr
  [attr]
  (-> (str (namespace attr) "__" (name attr))
      (str/replace #"\." "_")))

(defn text
  [{:keys [entity attr title initial-value]}]
  (let [id (munge-attr attr)]
    [c/Box {:maxWidth "33%"}
     [:label {:for id} [c/Text {:weight "bold"} title]]
     [c/TextFieldRoot
      {:id id
       :on-change (fn [e] (swap! entity assoc attr (.. e -target -value)))
       :default-value (or initial-value
                          (get @entity attr))}]]))

(defn text-area
  [{:keys [entity attr title]}]
  (let [id (munge-attr attr)]
    [c/Box {:maxWidth "33%"}
     [:label {:for id} [c/Text {:weight "bold"} title]]
     [c/TextArea
      {:id id
       :resize "vertical"
       :on-change (fn [e] (swap! entity assoc attr (.. e -target -value)))
       :default-value (get @entity attr)}]]))

(defn select
  [{:keys [entity attr title options placeholder]}]
  (let [id (munge-attr attr)
        placeholder (or placeholder title)
        value (get @entity attr)
        ]
    [c/Box {:maxWidth "33%"}
     (when title
       [:label {:for id} [c/Text {:weight "bold"} title]])
     [c/SelectRoot
      {:value (pr-str value)
       :onValueChange (fn [string-value]
                        (let [value (edn/read-string string-value)]
                          (swap! entity assoc attr value)))}
      [c/SelectTrigger
       (or placeholder
           ;; TODO this should be option title not value
           value)]
      (into [c/SelectContent]
            (map (fn [{:keys [title value]}]
                   [c/SelectItem {:value (pr-str value)} title]))
            options)]]))

(defn radio-cards
  [{:keys [entity attr title options]}]
  (let [id (munge-attr attr)]
    [c/Box {:maxWidth "100%"}
     (when title
       [:label {:for id} [c/Text {:weight "bold"} title]])
     ;; TODO doesn't have :for attr?
     (into [c/RadioCardsRoot
            {:value (pr-str (get @entity attr))
             :onValueChange (fn [string-value]
                              (let [value (edn/read-string string-value)]
                                (swap! entity assoc attr value)))
             :columns "repeat(auto-fit, 160px)"}]
           (map (fn [{:keys [value component]}]
                  [c/RadioCardsItem {:value (pr-str value)}
                   component]))
           options)]))

(defn cancel
  [{:keys [in-flight? on-click]}]
  [c/Button
   {:disabled @in-flight?
    :on-click on-click
    :size "2"
    :color "crimson"
    :variant "outline"}
   "Cancel"])
